import { TRYON_SERVER_URL } from "../../config";

export function mediaUrl(path) {
    if (!path) return "";
    if (String(path).startsWith("http")) return path;
    return `${TRYON_SERVER_URL}/${String(path).replace(/^\//, "")}`;
}

export function pieceName(image) {
    const brand = image?.garment_brand;
    if (brand && brand !== "Unknown") return brand;
    return "Garment";
}

export function usableImages(images) {
    return (images || []).filter((image) =>
        image?.image_url && image.preprocessing !== "failed" && image.preprocessing !== "failure"
    );
}
